module.exports = __webpack_public_path__ + "static/media/dean-m.3d5dd9fb.jpg";